export default "Partial Common Ownership reduces the <b>investor hoarding problem</b>.\n";